const $propertyDetailsAH      = $("#aj-qv-sec-property-details").find(".accordion-heading"),
      $openHouseAH            = $("#aj-qv-open-house").find(".accordion-heading");

export const abTestOpenSections = () => {
  let sections;
  if (MOVE.LocalStorage.isAvailable) {
    if (MOVE_DATA.ab_qv_open_card === "V1"){
      sections = '#collapse-open-house';
    } else if(MOVE_DATA.ab_qv_open_card === "V2"){
      sections = '#collapse-open-house, #collapse-property-details';
    }
  }
  return sections;
}

export const propertyDetailsAHListener = () => {
  $propertyDetailsAH.click(function() { 
    if (MOVE_DATA.ab_qv_open_card === "V1" && !$propertyDetailsAH.hasClass("collapsed")) {
      let isOHOpen = localStorage.getItem('quickview-sections') === "#collapse-open-house";
      if (isOHOpen) {
        let localStorageItems = localStorage.getItem('quickview-sections');
        localStorage.setItem(
          'quickview-sections', [localStorageItems, "#collapse-property-details"].join(",")
        );
      }
    }
  });
}

export const propertyDetailsSetStorage = () => {
  $propertyDetailsAH.click(function() { 
    if (MOVE_DATA.ab_qv_open_card === "V1" && !$propertyDetailsAH.hasClass("collapsed")) {
      let isOHOpen = localStorage.getItem('quickview-sections') === "#collapse-open-house";
      if (isOHOpen) {
        let localStorageItems = localStorage.getItem('quickview-sections');
        localStorage.setItem(
          'quickview-sections', [localStorageItems, "#collapse-property-details"].join(",")
        );
      }
    }
  });
}

export const addOpenPanelsABTracking = () => {
  let trackingSections = "no_sections_open";
  if ($propertyDetailsAH && !$propertyDetailsAH.hasClass("collapsed"))
    trackingSections = "collapse-property-details";
  if ($openHouseAH  && !$openHouseAH.hasClass("collapsed"))
    trackingSections = "collapse-open-house";
  if ($propertyDetailsAH && $openHouseAH) {
    if (!$propertyDetailsAH.hasClass("collapsed") && !$openHouseAH.hasClass("collapsed"))
      trackingSections = "collapse-open-house, collapse-property-details";
  }
  return trackingSections;
}


// WEBPACK FOOTER //
// ./quick_view/optimization/ab-open-panels.js